// removed by extract-text-webpack-plugin
module.exports = {"blue_btn":"buttons__blue_btn__Z99gK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/widgets/Buttons/buttons.css
// module id = 833
// module chunks = 0